import { MojaFirmaClient, SubscriptionPackage } from '@kodit/core/data-api';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@kodit/core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-podesavanje-racuna-page',
  templateUrl: './podesavanje-racuna-page.component.html',
  styleUrls: ['./podesavanje-racuna-page.component.scss']
})
export class PodesavanjeRacunaPageComponent implements OnInit {

  private _subs: Subscription = new Subscription();
  displayPlacanjeStarihRacuna: boolean = false;
  displayPodesavanjaRacuna: boolean = false;

  constructor(
    private _client: MojaFirmaClient,
    private _authService: AuthService
  ) { }

  ngOnInit(): void {
    this.displayPodesavanjaRacuna = this._authService.hasPackage([
      SubscriptionPackage[SubscriptionPackage.EFAKTURE],
      SubscriptionPackage[SubscriptionPackage.MALOPRODAJA],
      SubscriptionPackage[SubscriptionPackage.VELEPRODAJA],
      SubscriptionPackage[SubscriptionPackage.BESPLATNO],
    ]);

    this._subs.add(
      this._client
        .getKonfiguracija()
        .subscribe(
          (res) => {
            this.displayPlacanjeStarihRacuna = res.data.displayPlacanjeStarihRacuna;
          }
        )
    );
  }

}
